import * as React from 'react';

import { NoteComments } from '../NoteComments';

/**
 * Панель комментариев для сайдбара PDF-просмотрщика.
 *
 * Внедряется в PDFViewer вместо его встроенной SidebarComments, которая
 * (а) пишет через /PDFNoteComments/save, а в контрагентском API этого
 * эндпоинта нет — контроллер только на чтение, и
 * (б) читает комментарии без фильтра NotForContractor, то есть показала бы
 * контрагенту внутреннюю переписку ГИП и экспертов.
 *
 * NoteComments уже фильтрует NotForContractor: false и работает только
 * на чтение — ровно то, что нужно.
 */
export const ContractorCommentsPanel: React.FC<{ noteId: number }> = ({ noteId }) => (
    <NoteComments noteId={noteId} onCommentsChanged={() => { }} />
);
